module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av617-e2e7a606865cf6f03a52d6cbdda4c8ee.jpg";